<script lang="ts" setup>
import {
  TaxonomyTermToccoCountry,
  TaxonomyTermToccoNativeLanguage,
  TermsByNameDocument,
  TermsDocument,
} from '~/api/graphql/generated'
import type { TermsByNameQueryVariables, TermsQueryVariables } from '~/api/graphql/generated'
import { Option } from '~/components/atoms/forms/select/Select.vue'
import { useTypedAsyncQuery } from '~/lib/utils/graphqlDocument'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { languageCODE } = useLocale()
const termsVariables: TermsQueryVariables = {
  limit: 250,
  vocabulary: 'tocco_country',
  language: languageCODE.value,
}
const { data: termsData } = await useTypedAsyncQuery(TermsDocument, termsVariables)

const nationalityOptions = reactive({
  entities: (termsData.value?.taxonomyTermQuery?.entities as TaxonomyTermToccoCountry[])?.map((entity): Option => ({
    label: entity?.name ?? '',
    value: entity?.fieldExternalId ?? '',
  })),
})

const languageVariables: TermsByNameQueryVariables = {
  limit: 250,
  vocabulary: 'tocco_native_language',
  language: languageCODE.value,
}
const { data: languageData } = await useTypedAsyncQuery(TermsByNameDocument, languageVariables)

const languageOptions = reactive({
  entities: (languageData.value?.taxonomyTermQuery?.entities as TaxonomyTermToccoNativeLanguage[])?.map(
    (entity): Option => ({
      label: entity?.name ?? '',
      value: entity?.fieldExternalId ?? '',
    }),
  ),
})

const selectedNationality = ref('')
const showPlaceOfOrigin = computed(() => selectedNationality.value === '43') // 43 is the External Tocco ID for Schweiz.
</script>

<template>
  <div class="form-section--2-cols">
    <Date
      id="personal-details-birthdate"
      name="birthdate"
      :label="t('tocco.registration.personalDetails.birthdate')"
      :required="true"
    />

    <Select
      id="personal-details-nationality"
      v-model="selectedNationality"
      name="nationality"
      :label="t('tocco.registration.personalDetails.nationality')"
      :required="true"
      :options="nationalityOptions.entities"
    />
  </div>

  <div class="form-section--2-cols">
    <Select
      id="personal-details-language"
      name="language"
      :options="languageOptions.entities"
      :label="t('tocco.registration.personalDetails.language')"
      :required="true"
    />

    <Input
      v-if="showPlaceOfOrigin"
      id="personal-details-place-of-origin"
      name="place_of_origin"
      :label="t('tocco.registration.personalDetails.placeOfOrigin')"
      :required="true"
    />
  </div>
</template>
